import AppUserType from "~/constants/AppUser/AppUserType";

const AuthenticatedUserHelper = {
  /**
   * Is authenticated
   *
   * At the client panel we pass the authenticated User
   * and if not authenticated an empty User (new User({}))
   * If the appUserId is not 0, that's a good sign we received the authenticated User
   * @param user
   * @returns {boolean}
   */
  isAuthenticated: user => {
    if (user === null || !Number.isInteger(user.appUserId)) {
      return false;
    }

    return user.appUserId > 0;
  },
  /**
   * Is authenticated Customer
   *
   * @param user
   * @returns {boolean}
   */
  isAuthenticatedCustomer: user => {
    if (user === null) {
      return false;
    }

    return user.type === AppUserType.CUSTOMER;
  },
  /**
   * Is authenticated special Urbanimmersive user (Tourbuzz provider under the hood).
   */
  isAuthenticatedMyUrbanimmersiveProvider: user => {
    if (user === null) {
      return false;
    }

    return user.type === AppUserType.PROVIDER && user.provider.isMyUrbanimmersive;
  },
};

export default AuthenticatedUserHelper;
